import type { EligibilityViewStatus } from '@galapagos/shared';
import { sponsorRewardsOn, type LinkIncentive } from '@/services/link-incentive';
import type { SignupSponsor } from '../services/signup-api/signup-api';

/**
 * Whether the rewards surfaces show: the sponsor has rewards on, the link's
 * incentive code does not say "no incentive", and the eligibility check has
 * not come back unresolved. Production hides them once its check reports no
 * roster match; the Galapagos check never says "ineligible", so an unmatched
 * member surfaces here as `needs_review`. A missing or failed sponsor read
 * counts as rewards off.
 */
export function showRewards(
  sponsor: SignupSponsor | undefined,
  eligibilityStatus: EligibilityViewStatus | null,
  incentive?: LinkIncentive,
): boolean {
  return (
    sponsorRewardsOn(sponsor?.features.rewards, incentive) && eligibilityStatus !== 'needs_review'
  );
}
